import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import { mdi } from "vuetify/iconsets/mdi";
import { StringDateAdapter } from "vuetify/date/adapters/string";
import { vuetify3 as pakenergyTheme } from "@pakenergy/design-system/vuetify";

export default createVuetify({
  components,
  directives,
  date: {
    adapter: StringDateAdapter,
  },
  icons: {
    defaultSet: "mdi",
    sets: { mdi },
  },
  defaults: {
    VCheckbox: {
      color: "primary",
    },
    VTextField: {
      color: "primary",
    },
    VSelect: {
      color: "primary",
    },
    VDataTable: {
      itemsPerPageText: "Rows per page:",
      itemsPerPageOptions: [25, 50, 75, 100, -1],
      itemsPerPage: 50,
    },
    VDataTableServer: {
      itemsPerPageText: "Rows per page:",
      itemsPerPageOptions: [25, 50, 75, 100, -1],
      itemsPerPage: 50,
    },
    VDatePicker: {
      color: "primary",
      controlVariant: "modal",
      hideHeader: true,
    },
  },
  theme: {
    defaultTheme: "pakenergy",
    themes: {
      pakenergy: {
        ...pakenergyTheme,
        colors: {
          ...pakenergyTheme.colors,
          metadataHighlight: "#f2f2ab",
        },
      },
    },
  },
});
